import OptionToggle from '~/components/OptionToggle';
import React from 'react';

const HideSpotsLeftSetting = ({ settings, setSettings, className }) => {
    return (
        <OptionToggle
            value={settings?.hideSpotsLeft}
            onChange={value =>
                setSettings({
                    ...settings,
                    hideSpotsLeft: value,
                })
            }
            title="Hide Spots Left"
            description="Hide number of spots left for class/group events"
            className={className}
        />
    );
};

export default HideSpotsLeftSetting;
